import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ErrorService } from '@cosmos/angular/utils';
import { DailyWeatherDto } from '@cosmos/shared';
import { catchError, map, Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AiService {
  constructor(
    private readonly http: HttpClient,
    private readonly errorService: ErrorService,
  ) {}

  getConcretingAdvice(projectId: string, forecast: DailyWeatherDto[]): Observable<{ advice: string }> {
    return this.http
      .post<{ advice: string }>(
        `${environment.API_URL}/ai/weather/concreting-advice`,
        { projectId, forecast },
      )
      .pipe(
        map(response => response),
        catchError(error => { this.errorService.handleError(error); throw error; }),
      );
  }
}
